import axios from "axios";
import sistemaStore from "./sistema";
import { getClientesDB, getProdutosEmAbertoDB } from "@/db/clientes";

const getDefaultState = () => {
  return {
    clientes: [],
    clienteManut: null,
    editar: false,
    cadpros: [],
    estadosCivis: [
      { descricao: "Nenhum", value: 99, conjuge: false },
      { descricao: "Casado", value: 2, conjuge: true },
      { descricao: "Solteiro", value: 1, conjuge: false },
      { descricao: "Divorciado/Desquitado", value: 3, conjuge: false },
      { descricao: "Viúvo", value: 4, conjuge: false },
      { descricao: "Outros", value: 5, conjuge: true },
    ],
    produtosEmAberto: [],
  };
};

const clientesStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setClientes(state, clientes) {
      state.clientes = clientes;
    },
    setClienteManut(state, value) {
      state.clienteManut = value;
    },
    setEditar(state, value) {
      state.editar = value;
    },
    setProdutosEmAberto(state, prods) {
      state.produtosEmAberto = prods;
    },
    setCadpros(state, cadpros) {
      state.cadpros = cadpros;
    },
  },
  actions: {
    async getClientes(context, params) {
      try {
        sistemaStore.state.errorRequest = false;

        if (navigator.onLine) {
          const res = await axios.get(
            "/nutricao-animal/clientes/listar-clientes",
            {
              params: params,
            }
          );
          if (res.data.success) {
            return res.data.data;
          } else {
            sistemaStore.state.errorRequest = true;
            sistemaStore.state.msgError = res.data.msg;
          }
        } else {
          var clientesDB = await getClientesDB();
          var clientesFiltrados = [];

          clientesDB
            .filter(
              (c) =>
                c.nome.toLowerCase().includes(params.pesquisa.toLowerCase()) ||
                c.matricula == params.pesquisa
            )
            .forEach((c) => {
              if (clientesFiltrados.length < 12) {
                clientesFiltrados.push(c);
              }
            });

          return clientesFiltrados;
        }

        return [];
      } catch (error) {
        sistemaStore.state.errorRequest = true;
        sistemaStore.state.msgError = error;
        return [];
      }
    },
    async getPerfil(context, params) {
      try {
        const res = await axios.get("/nutricao-animal/clientes/perfil", {
          params: params,
        });
        return res.data.data;
      } catch (error) {
        return [];
      }
    },
    async getProdutosEmAberto(context, params) {
      context.commit("setProdutosEmAberto", []);
      if (navigator.onLine) {
        await axios
          .get("/nutricao-animal/clientes/produtos-em-aberto", {
            params: params,
          })
          .then((res) => {
            if (res.data.success) {
              context.commit("setProdutosEmAberto", res.data.data);
            }
          });
      } else {
        var prodAbertosDB = await getProdutosEmAbertoDB();
        context.commit(
          "setProdutosEmAberto",
          prodAbertosDB.filter((p) => p.matricula == params.pesquisa)
        );
      }
    },
    async getCadpros(context, params) {
      context.commit("setCadpros", []);
      await axios
        .get("/nutricao-animal/cadpro/listar-cadpros", {
          params: params,
        })
        .then((res) => {
          if (res.data.success) {
            context.commit("setCadpros", res.data.data);
          }
        });
    },
  },
  getters: {
    isPreencherConjuge(state) {
      return state.estadosCivis.find(
        (ec) => ec.value == state.clienteManut.estadocivil
      ).conjuge;
    },
    isSelecPessoaJurid(state) {
      return state.clienteManut.tipo == "J";
    },
  },
};

export default clientesStore;
